import { ReactNode, useMemo } from 'react';
import { useCart } from 'contexts/CartContext/CartContext.hooks';
import AccessoryCard from 'pages/Cart/Cards/Accessory/AccessoryCard';
import { useCartSectionStyles } from '../Sections.styles';
import { IAccessorySectionProps } from './AccessorySection.types';

const AccessorySection = (props: IAccessorySectionProps) => {
    const { readonly } = props;

    const { cart } = useCart();
    const styles = useCartSectionStyles();

    const accessoryCards: ReactNode[] = useMemo(
        () =>
            cart.accessories.map((accessory) => (
                <AccessoryCard
                    key={`${accessory.product.baseInfo.name}-card`}
                    readonly={readonly}
                    accessory={accessory}
                />
            )),
        [cart.accessories, readonly]
    );

    if (cart.accessories.length <= 0) return <></>;

    return (
        <div className={styles.lineSection}>
            <h1 className={styles.header}>Accessories</h1>
            {accessoryCards}
        </div>
    );
};

export default AccessorySection;
